import classNames from 'classnames';

import styles from './styles.module.scss';

interface ContrastedTitleProps {
  title: string;
  inOrderSummary: boolean;
}

export const ContrastedTitle = ({ title, inOrderSummary }: ContrastedTitleProps) => (
  <div
    className={classNames(styles.contrastedText, {
      [styles.orderSummary]: inOrderSummary,
    })}
  >
    {title}
  </div>
);
